import { actionTypesDelivery as actionTypes, actionTypesStockTransfer as transferActionTypes } from "../constants/actionTypesDelivery";
import { deliveryState } from "../state/delivery";
import { stockTransferState } from "../state/stockTransfer";
import { setItemInSessionStorage } from "../../services/utils/storageService";

export const deliveryReducer = (state = deliveryState, action: any) => {
  switch (action.type) {
    case actionTypes.ListOfDelivery:
      return {
        ...state,
        deliveryList: action.payload,
        isDeliveryListLoaded: true,
      };
    case actionTypes.IsDeliveryTableRefreshed:
      return {
        ...state,
        isDeliveryTableRefreshed: action.payload,
      };
    case actionTypes.SelectedDelivery:
      return {
        ...state,
        selectedDelivery: action.payload,
      };
    case actionTypes.AddRecentUpload: {
      const incoming = action.payload;
      let updatedUploads = (state.recentUploads || []).filter(
        (u: any) => u.docNum !== incoming.docNum
      );

      if (incoming.files && incoming.files.length > 0) {
        updatedUploads = [incoming, ...updatedUploads];
      }

      setItemInSessionStorage("recentUploads", JSON.stringify(updatedUploads));
      return {
        ...state,
        recentUploads: updatedUploads,
      };
    }
    default:
      return state;
  }
};

export const stockTransferReducer = (state = stockTransferState, action: any) => {
  switch (action.type) {
    case transferActionTypes.ListOfStockTransfer:
      return {
        ...state,
        stockTransferList: action.payload,
        isStockTransferListLoaded: true,
      };
    case transferActionTypes.IsStockTransferTableRefreshed:
      return {
        ...state,
        isStockTransferTableRefreshed: action.payload,
      };
    case transferActionTypes.SelectedStockTransfer:
      return {
        ...state,
        selectedStockTransfer: action.payload,
      };
    default:
      return state;
  }
};
